module.exports = __webpack_public_path__ + "img/p2.c1c2d11.jpg";